import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import saveAs from 'file-saver';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { DepartmentAppVerificationModel } from 'src/app/models/department-app-verification.model';
import { DepartmentESTVerificationModel } from 'src/app/models/department-est-verification.model';
import { Table } from 'primeng/table';
import { TokenService } from 'src/app/services/common/token.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { BankDetail } from '../../../registration/bank-details/bankDetails';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';


@Component({
  selector: 'app-mi-vendor-application-verification-approved',
  templateUrl: './mi-vendor-application-verification-approved.component.html',
  styleUrls: ['./mi-vendor-application-verification-approved.component.scss']
})

export class MiVendorApplicationVerificationApprovedComponent implements OnInit {

  @ViewChild('estVerificationTable', { static: true }) public estVerificationTable: Table;

  addBankDialog: boolean;
  fileName = 'ExcelSheet.xlsx';
  bankAccountList: BankDetail[] = [];

  bankAccount: BankDetail;

  selectedBankAccounts: BankDetail[];

  submitted: boolean;
  appVerificationItems: MenuItem[];
  vendorEstVerificationItems: MenuItem[];

  statuses: any[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  farmerId: any;
  bankList: any;
  filteredBankList: any[];
  estVerificationModel: DepartmentESTVerificationModel[];

  public userID: any;
  public loading: boolean = false;
  public subscriptions: any = [];

  public subjectSub:any;
  public selectedYear:any;

  constructor(
    private messageService: MessageService, 
    private deptDashBoardService: DepartmentDashboardService, 
    private router: Router, 
    private tokenService: TokenService, 
    private cryptoJsService: CryptoJsService, 
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService
    ) { }

  ngOnInit() {
    sessionStorage.setItem('currentComponentName', 'miVendorApplicationForApprovalApproved');
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    // this.activityRecordService.activityRecord(this.userID, 'Vendor MI Estimation For Approval', '', new Date(), 'Success');
    // this.loadData();
    this.loadDataAndApplyFilter();
    // this.estVerificationTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];

    this.vendorEstVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportMiVendorExcel(this.estVerificationModel, "Vendor_MI_EST_List");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadVendorMiSheetAsPdf(this.estVerificationModel, "Vendor_MI_EST_List");
        }
      },
    ];

  }


  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        // this.estVerificationTable.clear();

        // let router=this.router.url
        // this.routePath=router.split('/')

        
        this.selectedYear = res;
        this.loadData();
        this.estVerificationTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }


  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  onFiltering(event: any) {
    // console.log('Filtered value: ' + JSON.stringify(event.filters));
  }

  loadData() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (sessionStorage.getItem("miVendorApplicationForApprovalApproved") != 'null' && (sessionStorage.getItem("miVendorApplicationForApprovalApproved") && 
    JSON.parse(window.sessionStorage.getItem('miVendorApplicationForApprovalApproved'))[0]?.FinYear == this.selectedYear)){
      this.estVerificationModel = JSON.parse(window.sessionStorage.getItem("miVendorApplicationForApprovalApproved"));
      // this.activityRecordService.activityRecord(this.userID, 'Vendor MI Estimation For Approval (Approved)', '', new Date(), 'Success');
      // console.log(this.estVerificationModel,"data")
    } else {
      let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      // this.loader.start();
      this.loading = true;
      let sub =this.deptDashBoardService.getVendorMIEstimationsForApproval(JSON.parse(payload)?.sub, 'Approved', this.selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            data.AppEstimate.forEach(e=>{
              e.EstimationDate=new Date(e.EstimationDate);
              e.AssignedDate = new Date(e?.AssignedDate);
              e.ActionDate = new Date(e?.ActionDate);

              e.EstimationDate_filter=e.EstimationDate.toString().substring(4, 24)
            })
            if (data.AppEstimate?.length > 0) {
              // this.activityRecordService.activityRecord(this.userID, 'Vendor MI Estimation For Approval (Approved)', '', new Date(), 'Success');
              this.estVerificationModel = data.AppEstimate;
              // console.log(this.estVerificationModel,"data")
              sessionStorage.setItem('miVendorApplicationForApprovalApproved', JSON.stringify(this.estVerificationModel));
            }
            else{
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.estVerificationModel=[]
            }
          },
          error: (err) => {
            // this.loader.close();
            this.estVerificationModel = [];
            this.loading = false;
            // this.activityRecordService.activityRecord(this.userID, 'Vendor MI Estimation For Approval (Pending)', '', new Date(), err);
            if(err == 'Data not Found!'){
              this.messageService.add({
                severity: 'info',
                summary: 'Info Message',
                detail: 'No Data Found',
              });
            }else{
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: err,
              });
            }
          }
        });

        this.subscriptions.push(sub);
    }
  }

  refreshTable() {
    sessionStorage.removeItem('miVendorApplicationForApprovalApproved');
    // this.loadData();
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
    this.loadDataAndApplyFilter();
  }

  hideDialog() {
    this.addBankDialog = false;
    this.submitted = false;
  }

  miEstimationPrintForm(appId, vendorId, programId, statusCode) {
    if (appId) {
      let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'vendor-estimate', 'print', appId, vendorId, programId], { queryParams: { statusCode: statusCodeEncrypted } }));
      // window.open(link, '_blank');
      this.router.navigate(['department', 'vendor-estimate', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()), vendorId:this.cryptoJsService.Encrypt(vendorId.toString()), programId:this.cryptoJsService.Encrypt(programId.toString()), statusCode: statusCodeEncrypted } });

      // this.router.navigate(['department', 'vendor-estimate', 'print', this.cryptoJsService.Encrypt(appId), vendorId, programId], { queryParams: { statusCode: statusCodeEncrypted } });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  //Vendor MI Estimation Download Options
  downloadVendorMiSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'AppUserType', header: 'App User Type'},
      { field: 'AppID', header: 'APP ID' },
      { field: 'Remarks', header: 'Remarks' },
      { field: 'FarmerName', header: 'Farmer Name' },
      { field: 'Caste_Description', header: 'Caste' },
      { field: 'Village', header: 'Village' },
      { field: 'Block', header: 'Block' },
      { field: 'District', header: 'District' },
      { field: 'VendorName', header: 'Vendor Name' },
      { field: 'Program', header: 'Program' },
      { field: 'PrograId', header: 'Program Id' },
      { field: 'VendorId', header: 'Vendor Id' },
      { field: 'EstimationDate', header: 'Estimation Date' },
      { field: 'Status', header: 'Status' },
      { field: 'Status_Ar', header: 'Current Status' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});
        doc.save(`${filename}.pdf`);
      })
    })
  }

  exportMiVendorExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "App User Type": d.AppUserType,
          "APP ID": d.AppID,
          "Remarks": d.Remarks,
          "Farmer Name": d.FarmerName,
          "Caste": d.Caste_Description,
          "Village": d.Village,
          "Block": d.Block,
          "District": d.District,
          "Vendor Name": d.VendorName,
          "Program": d.Program,
          "Program Id": d.PrograId,
          "Vendor Id": d.VendorId,
          "Estimation Date": d.EstimationDate,
          "Status": d.Status,
          "Current Status": d.Status_Ar,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  rowBackgroundColor(product){
    if(product.Status_Ar == 'P'){
      if(product.Pending_CompletedDays <= -2){
        return '#ff8080';
      }
      else if(product.Pending_CompletedDays == -1){
        return '#ffc966';
      }
    }
    else if(product.Status_Ar == 'C' || product.Status_Ar == 'A'){
      if(product.Pending_CompletedDays >= -1){
        return '#99e699';
      }
      else if(product.Pending_CompletedDays <= -2){
        return '#ffb3b3';
      }
    }
    else
      return '#ffffff';
  }

}
